import type { Mutation, MutationOp } from '../mutations';
import type { BuildCtx } from '../spending/types';

/** RESERVED_KEYS (conventions §4): the appliers set them; a builder that puts them in values is a bug. */
const APPLIER_KEYS = ['id', 'userId', 'createdAt', 'updatedAt', 'deletedAt', 'clock'] as const;

export type BudgetResult<T, E extends string> = ({ ok: true } & T) | { ok: false; error: E };

/** Same shape as Spending's builder helper, with source 'budget', so tests control ids through ctx.newId. */
export function budgetMutation(
  ctx: BuildCtx,
  table: string,
  op: MutationOp,
  rowId: string,
  values?: Record<string, unknown>,
  opts: { ifAbsent?: true } = {},
): Mutation {
  for (const k of APPLIER_KEYS) {
    if (values && k in values) throw new Error(`Mutation values must not include '${k}'`);
  }
  return {
    id: ctx.newId(),
    table,
    op,
    rowId,
    ...(values ? { values } : {}),
    at: ctx.now,
    source: 'budget',
    ...(opts.ifAbsent ? { ifAbsent: true as const } : {}),
  };
}
